import { useState } from 'react';
import dayjs from 'dayjs';
import { t } from 'ttag';

import BalloonIcon from '@svg/balloon.svg';
import MessageInfoIcon from '@svg/message-info.svg';
import { Alert } from '@ui/Alert';
import { Button } from '@ui/Button';
import { FreePushUpInfoModalContainer } from '@containers/FreePushUpInfoModal';

import s from './ProductDetailsFreePushAlert.sss';

interface Props {
  nextFreePushupAt?: string | null,
  freePushupAvailable?: boolean | null,
}

export const ProductDetailsFreePushAlert: React.FC<Props> = ({
  nextFreePushupAt,
  freePushupAvailable,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dateFormated = dayjs(nextFreePushupAt).format('DD.MM.YYYY');
  let text = t`Для цього товару доступне безкоштовне підняття з ${dateFormated}`;

  if (freePushupAvailable) {
    text = t`Для цього товару доступне безкоштовне підняття`;
  }

  return (
    <>
      <Alert
        className={s.alert}
        theme={freePushupAvailable ? 'info' : 'warning'}
      >
        <BalloonIcon
          className={s.icon}
          width="24"
          height="24"
        />

        {text}

        <Button
          className={s.button}
          theme="text"
          onClick={() => setIsModalOpen(true)}
        >
          <MessageInfoIcon
            width="16"
            height="16"
          />
        </Button>
      </Alert>

      <FreePushUpInfoModalContainer
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
